import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  measurements: [],
};

const measurementsSlice = createSlice({
  name: 'measurements',
  initialState,
  reducers: {
    // Додає заміри
    addMeasurementsRedux(state, { payload }) {
      state.measurements = payload;
      // console.log(payload);
    },
  },
});

export const { addMeasurementsRedux } = measurementsSlice.actions;

export default measurementsSlice.reducer;
